/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".copy[_ngcontent-%COMP%]{width:1em;height:1em;margin:0 0 0 .3em;fill:#fff;transform:translateY(-10%)}"];
export { styles as styles };
